import styled from "styled-components";

export const I = styled.i`
  color: ${props => props.theme.colors.secondary};
`;

export const TInput = styled.input`
  color: ${props => props.theme.colors.secondary};
`;

export const Label = styled.label`
  color: ${props => props.theme.colors.secondary};
`;
